<template>
    <div class="row p-3">
        <input-radio class="col-12" label="Alcançado?" :options="options.simnao" v-model="form.alcancado" ref="alcancado" required/>
        <input-textarea class="col-12" label="Justificativa" v-model="form.justificativa" ref="justificativa" :required="form.alcancado == 'N'" :readonly="form.alcancado == 'S'" :max-length="1000" placeholder="Máximo 1000 caracteres"/>
        <input-textarea class="col-12" label="Funcionalidade" v-model="form.funcionalidade" ref="funcionalidade" required :max-length="1000" placeholder="Máximo 1000 caracteres"/>
        <input-textarea class="col-12" label="Abrangência" v-model="form.abrangencia" ref="abrangencia" required :max-length="1000" placeholder="Máximo 1000 caracteres"/>
        <input-textarea class="col-12" label="Âmbito" v-model="form.ambito" ref="ambito" required :max-length="1000" placeholder="Máximo 1000 caracteres"/>
        <div class="col-12">
            <b-button  variant="success" v-if="controlesLiberados && permissao.u"  @click="salvar">
                <i class="fa-solid fa-check mr-2"></i>
                Salvar
            </b-button>
        </div>
    </div>
</template>
<script>
import InputRadio from "@/components/inputs/InputRadio.vue";
import InputTextarea from "@/components/inputs/InputTextarea.vue";

import {FormMixin} from "@/common/mixins/FormMixin";

export default {
    name: "AplicabilidadePrevista",
    mixins: [FormMixin],
    components: {
        InputRadio,
        InputTextarea,
    },
    props : {
        objeto : {
            type : Object,
            default : () => ({
                alcancado: null,
                justificativa: "",
                funcionalidade: "",
                abrangencia: "",
                ambito: "",
            })
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data : () => ({
        options : {
            simnao : [
                { value : "S", text : "Sim" },
                { value : "N", text : "Não" },
            ]
        },
        form : {
            alcancado: null,
            justificativa: "",
            funcionalidade: "",
            abrangencia: "",
            ambito: "",
        }
    }),
    methods : {
        salvar : function(){
            this.$emit("salvar", this.form);   
        }
    },
    watch : {
        objeto : {
            handler : function(val){
                if(val)
                    this.form = val;
            },
            deep : true,
            immediate : true
        }
    },
    computed : {
        controlesLiberados :function(){
            return this.projetoEditavel
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdCaracteristicaProjeto');
        },
    }
}
</script>
<style lang="">
    
</style>